/* eslint-disable no-console */

import { register } from 'register-service-worker';

let refreshed = false;

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        '[FC-SW] App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB',
      );
    },
    registered() {
      console.log('[FC-SW] Service worker has been registered.');
    },
    cached() {
      console.log('[FC-SW] Content has been cached for offline use.');
    },
    updatefound() {
      console.log('[FC-SW] New content is downloading.');
    },
    updated() {
      console.log('[FC-SW] New content is available; please refresh.');
      if (navigator.onLine && !refreshed) {
        console.log('[FC-SW] Refreshing.');
        const meta = document.createElement('meta');
        meta.setAttribute('http-equiv', 'refresh');
        meta.setAttribute('content', '0;');

        const noscript = document.createElement('noscript');
        noscript.appendChild(meta);

        const body = document.getElementsByTagName('body')[0];
        body.appendChild(noscript);
        refreshed = true;

        window.location.reload(true);
      }
    },
    offline() {
      console.log('[FC-SW] No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('[FC-SW] Error during service worker registration:', error);
    },
  });
}
